import React from 'react';
import { FormField, RadioGroup } from '@amzn/awsui-components-react/';

const ControlledRadioGroupField = ({
  label,
  name,
  items,
  description,
  onChange,
  error,
  autofocus = false,
  stretch = true,
  required = false,
  value = false,
  disabled = false,
  hintText,
  fieldLabel,
}) => {
  return (
    <FormField
      className="awsui-util-d-b awsui-util-mb-m"
      description={description}
      errorText={error}
      stretch={stretch}
      label={fieldLabel}
      hintText={hintText}
    >
      <RadioGroup
        label={label}
        items={items}
        onChange={onChange}
        autofocus={autofocus}
        name={name}
        required={required}
        disabled={disabled}
        value={value}
      />
    </FormField>
  );
};

export default ControlledRadioGroupField;
